module.exports = __webpack_public_path__ + "img/no-data_law.6d0df91c.svg";